import commandEngine from './CommandEngine.js';
import jxWindowManager from '../../../../../JxControls/JxWindowManager/JxWindowManager.jsx';
import tabEngine from '../../../TabEngine/TabEngine.js';
import '../../../../../UmlWorkspace/UI/UmlSchemaDlg/UmlSchemaConfigDlg.jsx'; // side-effect: registreert 'UmlSchemaDlg' bij jxWindowManager

/**
 * Registers the /uml command with the CommandEngine.
 * Call once at module load from YourLibraryTab (zelfde patroon als registerClockCommand).
 *
 * /uml -> opent UmlSchemaDlg (properties-dialog: Start/Properties/Import-tabs, New/Load Existing).
 *
 * GEEN /uml <noteRk> meer (2026-07-09) — die tak opende rechtstreeks de canvas-kaart
 * ('uml:workspace:1') met een target-rk, maar niks las die rk ooit daadwerkelijk in
 * (index.jsx's fetch-logica die dat ooit deed is verwijderd, zie Jerny Source -
 * UmlWorkspace). Canvas-kaart openen gebeurt nu via UmlSchemaConfigDlg zelf
 * (handleNew/handleLoadSelected -> cardPainterManager.openCard), niet meer hier.
 * Rechtstreeks-via-command-met-rk kan later terugkomen als eigen, afgeronde
 * functionaliteit — niet als bijeffect van deze command.
 *
 * Owner is de actieve tab-id (niet 'global' zoals clockCommand) — UmlSchemaDlg is een
 * gewone tab-gebonden dialoog en moet sluiten (JxWindowManager.paint() -> open=false)
 * zodra de gebruiker naar een andere tab wisselt. LoadUmlSchemaDlg is child van
 * UmlSchemaDlg's render() en volgt daarin automatisch mee.
 */
export function registerUmlCommand() {
    commandEngine.register('/uml', {
        hint: 'Open UML workspace',
        params: [],
        handler: () => {
            const existing = jxWindowManager.getAllWindows().find((w) => w.name === 'UmlSchemaDlg');
            if (existing) return;

            const ownerTabId = tabEngine.getActiveTab()?.id ?? 'global';
            jxWindowManager.openWindow('UmlSchemaDlg', ownerTabId, { autoNew: true }, true);
        },
    });
}
